/**
 * categoryStorage — 本地分类存储工具
 * 未登录时使用 localStorage 保存用户选择的分类
 */

const STORAGE_KEY = 'local_categories';

/**
 * 获取本地保存的分类列表
 * @returns {Array} 分类数组，格式与 getCategoryList API 返回一致
 */
export function getLocalCategories() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * 保存分类到 localStorage
 * @param {Array} categories - 分类数组 [{ id, category_name, pid }, ...]
 */
export function saveLocalCategories(categories) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
  } catch (e) {
    console.warn('[categoryStorage] save failed:', e);
  }
}

/**
 * 清除本地分类
 */
export function clearLocalCategories() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * 是否有本地保存的分类
 * @returns {boolean}
 */
export function hasLocalCategories() {
  return getLocalCategories().length > 0;
}
